/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable eqeqeq */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/quotes */
import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CategoryService } from "../../category/category.service";
import { SubCategoryService } from "../../sub-category/sub-category.service";
import { QuestionAnswerKeywordService } from "../question-answer-keyword.service";

@Component({
  selector: "app-add-edit-question-answer-keyword",
  templateUrl: "./add-edit-question-answer-keyword.component.html",
  styleUrls: ["./add-edit-question-answer-keyword.component.scss"],
})
export class AddEditQuestionAnswerKeywordComponent implements OnInit {
  questionEng: string = "";
  questionMar: string = "";
  answerEng: string = "";
  answerMar: string = "";
  keywordEng: string = "";
  keywordMar: string = "";

  selectedCategory: any = null;
  categories: any[] = [];

  selectedSubCategory: any = null;
  subCategories: any[] = [];

  queId = "";
  flag = "";
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private subCategoryService: SubCategoryService,
    private _snackBar: MatSnackBar,
    private categoryService: CategoryService,
    private questionAnswerKeywordService: QuestionAnswerKeywordService,
    public dialogRef: MatDialogRef<AddEditQuestionAnswerKeywordComponent>
  ) {}

  ngOnInit() {
    console.log(this.data);
    if (this.data[0] == "Edit") {
      this.flag = "E";
      this.queId = this.data[1]["pkQusid"];
      this.questionEng = this.data[1]["qusDescriptionEng"];
      this.answerEng = this.data[1]["qusAnswerEng"];
      this.keywordEng = this.data[1]["qusKeywordEng"];
      this.questionMar = this.data[1]["qusDescriptionMar"];
      this.answerMar = this.data[1]["qusAnswerMar"];
      this.keywordMar = this.data[1]["qusKeywordMar"];
    } else {
      this.queId = "";
      this.flag = "N";
    }
    this.getCategories();
  }

  async getCategories() {
    this.categories = [];
    const response: any = await this.categoryService.getCategories();
    console.log(response);
    if (!response.error) {
      if (response.length > 0) {
        this.categories = response;
        if (this.data[0] == "Edit") {
          var target = this.categories.find((temp) => temp.pkCatid == this.data[1]["fkCatid"]);
          console.log(target);
          this.selectedCategory = target;
          this.getSubCategories();
        }
      } else {
        this.warningToast();
      }
    } else {
      this.errorToast();
    }
  }

  async getSubCategories() {
    this.subCategories = [];
    await this.subCategoryService.getSubCategoriesV1(this.selectedCategory.pkCatid).subscribe((response: any) => {
      console.log(response);
      if (!response.error) {
        if (response.length > 0) {
          this.subCategories = response;
          if (this.data[0] == "Edit") {
            var target = this.subCategories.find((temp) => temp.pkSucid == this.data[1]["fkSucid"]);
            console.log(target);
            this.selectedSubCategory = target;
          }
        } else {
          this.warningToast();
        }
      } else {
        this.errorToast();
      }
    });
  }

  async saveQuestion() {
    const response: any = await this.questionAnswerKeywordService
      .saveQuestionV1(
        this.selectedCategory.pkCatid,
        this.selectedSubCategory.pkSucid,
        this.queId,
        this.questionEng,
        this.questionMar,
        this.keywordEng,
        this.keywordMar,
        this.answerEng,
        this.answerMar,
        this.flag
      )
      .subscribe((response: any) => {
        console.log(response);
        if (!response.error) {
          if (response.length > 0) {
            this.successToast();
          } else {
            this.warningToast();
          }
        } else {
          this.errorToast();
        }
      });
  }

  async successToast() {
    await this._snackBar.open("Category details saved successfully.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
    this.dialogRef.close("success");
  }

  async warningToast() {
    await this._snackBar.open(
      "Something went wrong while saving category details, please try again after sometime.",
      "Close",
      {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast() {
    await this._snackBar.open("Oops, something went wrong, please try after sometime.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }
}
